import { useParams } from "wouter";
import { motion } from "framer-motion";
import { appPages } from "@/lib/pages-data";
import { Construction } from "lucide-react";
import { useLocation } from "wouter";
import { useTranslation } from "@/lib/i18n/i18n";

import { PageHeader } from "@/components/PageHeader";
export default function PagePlaceholder() {
  const t = useTranslation();
  const params = useParams<{ id: string }>();
  const pageId = parseInt(params.id || "0");
  const page = appPages.find((p) => p.id === pageId);
  const [, setLocation] = useLocation();

  if (!page) {
    return (
      <div className="h-screen flex items-center justify-center bg-brand-muted-bg px-4">
        <div className="text-center max-w-md">
          <h1 className="text-xl sm:text-2xl font-bold text-brand-primary dark:text-gray-100 mb-2">{t("common.placeholder.pageNotFound")}</h1>
          <button onClick={() => setLocation("/")} className="text-sm text-brand-info-blue hover:underline">
            {t("common.placeholder.backHome")}
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="h-screen flex flex-col bg-brand-muted-bg">
      <PageHeader backLabel={t("common.placeholder.home")} breadcrumb={page.section} breadcrumbStyle="muted" />

      <div className="flex-1 flex items-center justify-center p-4 sm:p-8" role="status" aria-live="polite">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
          className="text-center max-w-lg w-full"
        >
          <div className="w-16 h-16 sm:w-20 sm:h-20 rounded-2xl bg-gradient-to-br from-brand-primary to-brand-info-blue flex items-center justify-center mx-auto mb-6">
            <Construction className="w-8 h-8 sm:w-10 sm:h-10 text-white" aria-hidden="true" />
          </div>

          <div className="text-sm font-mono text-brand-gold mb-2">{t("common.placeholder.pageLabel", { id: page.id })}</div>
          <h1 className="text-2xl sm:text-3xl font-bold text-brand-primary dark:text-gray-100 mb-2">{page.title}</h1>
          <p className="text-gray-400 text-sm mb-2">{page.section} / {page.part}</p>

          <div className="inline-flex items-center gap-2 mt-4 px-4 py-2 rounded-full bg-amber-50 border border-amber-200">
            <div className="w-2 h-2 rounded-full bg-amber-400 animate-pulse" />
            <span className="text-sm text-amber-700 font-medium">{t("common.placeholder.pendingConstruction")}</span>
          </div>
        </motion.div>
      </div>
    </div>
  );
}
